/**
 * 兼容各种情况， 不同型号的相同app包名类名可能不一致
 */

const replacePkgName = (
  config: ConfigParams,
  prevPkgName: string,
  nextPkgName: string,
) => {
  // 修改menu
  const menuMatched = config.menu?.builtinApp?.find(
    (a) => a.packageName === prevPkgName,
  );
  if (menuMatched) {
    menuMatched.packageName = nextPkgName;
  }
  // 修改layout
  const layoutMatched = config.layout?.app?.find(
    (a) => a.packageName === prevPkgName,
  );
  if (layoutMatched) {
    layoutMatched.packageName = nextPkgName;
  }
  // 修改sider
  const siderMatched = config.layout?.sider?.find(
    (a) => a.packageName === prevPkgName,
  );
  if (siderMatched) {
    siderMatched.packageName = nextPkgName;
  }
  // 修改folder
  config.layout?.folder?.forEach(({ child }) => {
    const folderMatched = child.find((a) => a.packageName === prevPkgName);
    if (folderMatched) {
      folderMatched.packageName = nextPkgName;
    }
  });
};

export const exportAdaptor = (product: Product, config: ConfigParams) => {
  if (product === 'gxv3370') {
    replacePkgName(config, 'com.gs.hwcontacts', 'com.gs.huaweicontacts');
  }

  return config;
};

export const importAdaptor = (product: Product, config: ConfigParams) => {
  if (product === 'gxv3370') {
    replacePkgName(config, 'com.gs.huaweicontacts', 'com.gs.hwcontacts');
  }

  return config;
};
